import { render, staticRenderFns } from "./general-settings.vue?vue&type=template&id=450398af"
import script from "./general-settings.vue?vue&type=script&lang=js"
export * from "./general-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports